import { apiSlice } from "../Slices/apiSlice";

export const tableService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get All Tables
    getAllTables: builder.query({
      query: () => "/table-management",
      providesTags: ["table", 'cart'],
    }),

    // Uncomment these when the backend APIs are available

    // getTableById: builder.query({
    //   query: (id) => `/table-management/${id}`,
    //   providesTags: ["table"],
    // }),

    // createTable: builder.mutation({
    //   query: (details) => ({
    //     url: "/table-management",
    //     method: "POST",
    //     body: details,
    //   }),
    //   invalidatesTags: ["table"],
    // }),

    // updateTable: builder.mutation({
    //   query: (details) => ({
    //     url: "/table-management",
    //     method: "PUT",
    //     body: details,
    //   }),
    //   invalidatesTags: ["table"],
    // }),

    // deleteTable: builder.mutation({
    //   query: (id) => ({
    //     url: `/table-management/${id}`,
    //     method: "DELETE",
    //   }),
    //   invalidatesTags: ["table"],
    // }),
  }),
});

export const {
  useGetAllTablesQuery,
  // useGetTableByIdQuery,
  // useCreateTableMutation,
  // useUpdateTableMutation,
  // useDeleteTableMutation,
} = tableService;